package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatTimestampToYYYYMMDDOrToHHMM
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceState
import com.essntl.features.itinerary.ui.edit_itinerary_service.rememberSender
import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EditItineraryServiceMessages(
    state: EditItineraryServiceState,
) {
    LazyColumn(
        verticalArrangement = Arrangement.spacedBy(1.spacing),
        horizontalAlignment = Alignment.Start,
        contentPadding = PaddingValues(top = 1.spacing),
        state = rememberLazyListState(),
        modifier = Modifier
            .fillMaxWidth()
            .heightIn(max = 300.dp),
    ) {
        if (state.whapiMessagesList.data.orEmpty().isEmpty())
            item {
                Text(
                    text = "No Messages",
                    style = MaterialTheme.esTypography.p2Medium14,
                )
            }
        else
            items(state.whapiMessagesList.data.orEmpty()) { message ->
                MessageCard(
                    state = state,
                    whapiMessage = message,
                )
            }
    }
}

@Composable
fun MessageCard(
    state: EditItineraryServiceState,
    whapiMessage: WhapiMessageModel,
) {
    val sender = state.rememberSender(whapiMessage)

    Column(
        verticalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = Modifier
            .fillMaxWidth()
            .border(
                width = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
                shape = RoundedCornerShape(2.spacing),
            )
            .clip(RoundedCornerShape(2.spacing))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(1.5f.spacing),
    ) {
        Text(
            "Sent ${formatTimestampToYYYYMMDDOrToHHMM(whapiMessage.timestamp.toString())}" +
                if (sender != null) " by ${sender.prettyName}" else "",
            style = MaterialTheme.esTypography.c1Medium13.copy(
                color = MaterialTheme.esColorScheme.textSecondary,
            ),
        )

        SelectionContainer {
            Text(
                whapiMessage.text ?: "",
                style = MaterialTheme.esTypography.c1Medium13.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
            )
        }
    }
}